'use client';

import ErrorMessage from '@/components/ui/ErrorMessage';

export default function Error({ reset }: { reset: () => void }) {
  return <ErrorMessage reset={reset} />;
}
